<template>
    <el-input
        v-if="type == 'integer'"
        v-model="numberValue"
        :placeholder="m_placeholder('请输入')"
        @focus="focus"
        @input="change"
        :clearable="clearable"
        :size="size"
        :disabled="readonly"
        class="integer width-p100"
    ></el-input>
    <el-input
        v-else-if="type == 'integer1'"
        v-model="numberValue"
        :placeholder="m_placeholder('请输入')"
        @focus="focus"
        @input="change"
        :clearable="clearable"
        :size="size"
        :disabled="readonly"
        class="integer width-p100"
    ></el-input>
    <el-input
        v-focus="autofocus"
        v-else-if="type == 'number'"
        v-model="numberValue"
        :placeholder="m_placeholder('请输入')"
        @focus="focus"
        @input="change"
        :clearable="clearable"
        :size="size"
        :disabled="readonly"
        @blur="blur"
        class="number width-p100"
    ></el-input>
    <el-input
        v-focus="autofocus"
        v-else-if="type == 'numberWithSlot'"
        v-model="numberValue"
        :placeholder="m_placeholder('请输入')"
        @focus="focus"
        @input="change"
        :clearable="clearable"
        :size="size"
        :disabled="readonly"
        @blur="blur"
        class="number width-p100"
    >
        <template slot="prepend">{{ slotValue }}</template>
    </el-input>
    <el-input
        v-focus="autofocus"
        v-else-if="type == 'float'"
        v-model="numberValue"
        :placeholder="m_placeholder('请输入')"
        :decimal_places="decimal_places"
        @focus="focus"
        @input="change"
        :clearable="clearable"
        :size="size"
        :disabled="readonly"
        @blur="blur"
        class="float width-p100"
    ></el-input>
    <el-input
        v-else-if="type == 'string'"
        v-focus="autofocus"
        v-model="textValue"
        :placeholder="m_placeholder('请输入')"
        @focus="focus"
        @input="change"
        :clearable="clearable"
        :disabled="readonly"
        :size="size"
        @blur="blur"
        class="string width-p100"
    ></el-input>
    <el-input
        v-else-if="type == 'string1'"
        v-focus="autofocus"
        v-model="textValue"
        :placeholder="m_placeholder('请输入')"
        @focus="focus"
        @input="change"
        :clearable="clearable"
        :disabled="readonly"
        :size="size"
        @blur="blur"
        @keyup.enter.native="blurchange"
        class="string width-p100"
    ></el-input>
    <el-input
        v-else-if="type == 'scan'"
        v-focus="autofocus"
        v-model="scan_val"
        :placeholder="m_placeholder('请扫码')"
        @focus="focus"
        @keyup.native.enter="enter"
        :clearable="clearable"
        :disabled="readonly"
        :size="size"
        @blur="blur"
        class="string width-p100"
    >
        <font-awesome-icon slot="append" v-if="isMobile" size="lg" :icon="['fas', 'barcode']" @click="scanActive ? openScan() : ''" />
    </el-input>
    <el-input
        v-else-if="type == 'textarea1'"
        type="textarea"
        style="margin-top: -10px !important;"
        :autosize="{ minRows: this.minRows, maxRows: this.maxRows }"
        v-model="textValue"
        :placeholder="m_placeholder('请输入内容')"
        @input="change"
        :clearable="clearable"
        :readonly="readonly"
        :disabled="readonly"
        :size="size"
        class="width-p100"
    ></el-input>
    <el-input
        v-else-if="type == 'textarea'"
        type="textarea"
        :autosize="{ minRows: this.minRows, maxRows: this.maxRows }"
        v-model="textValue"
        :placeholder="m_placeholder('请输入内容')"
        @input="change"
        :clearable="clearable"
        :readonly="readonly"
        :disabled="readonly"
        :size="size"
        class="width-p100"
    ></el-input>
    <el-input
        v-else-if="type == 'search'"
        v-model="textValue"
        :placeholder="m_placeholder('请输入关键字')"
        @focus="focus"
        @input="change"
        :clearable="clearable"
        :size="size"
        suffix-icon="el-icon-search"
        class="search width-p100"
    ></el-input>
    <el-image v-else-if="type == 'img'" style="width: 100px; height: 40px" :src="textValue" fit="contain" @click.native="imgclick" @contextmenu.prevent="imgdelete"
        ><div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i></div
    ></el-image>
    <el-cascader
        v-else-if="type === 'cascader'"
        :show-all-levels="true"
        v-model="selectValue"
        :filterable="true"
        :placeholder="m_placeholder('请选择')"
        :disabled="readonly"
        :options="_filterOptions"
        @change="change"
        :clearable="clearable"
        :size="size"
        class="select width-p100"
    ></el-cascader>
    <el-select
        v-else-if="type === 'select'"
        v-model="selectValue"
        filterable
        :allow-create="allowCreate"
        :placeholder="m_placeholder('请选择')"
        :disabled="readonly"
        remote
        :remote-method="filterMethod"
        @focus="filterMethod('')"
        @change="change"
        :clearable="clearable"
        :size="size"
        class="select width-p100"
        :popper-append-to-body="popperAppendToBody"
        :default-first-option="defaultFirstOption"
    >
        <el-option style="max-width: 900px !important;" v-for="op in _filterOptions" :key="op.value" :label="op.label" :value="op.value" :disabled="op.disabled">
            <el-col :span="22" class="selecttablelable" style="text-align: left;" :title="op.label">{{ op.label }}</el-col>
            <el-col :span="2" class="selecttablecode" :style="{ color: op.color || `#8492a6`,'text-align': 'right', 'font-size': '13px'}" :title="op.code">{{ op.code }}</el-col>
            <!-- <span style="float: left; padding-right: 20px">{{ op.label }}</span>
            <span :style="{ color: op.color || `#8492a6` }" style="float: right; font-size: 13px">{{ op.code }}</span> -->
        </el-option>
    </el-select>
    <el-select
        v-else-if="type === 'selectnotCode'"
        v-model="selectValue"
        filterable
        :allow-create="allowCreate"
        :placeholder="m_placeholder('请选择')"
        :disabled="readonly"
        remote
        :remote-method="filterMethod"
        @focus="filterMethod('')"
        @change="change"
        :clearable="clearable"
        :size="size"
        class="select width-p100"
        :popper-append-to-body="popperAppendToBody"
        :default-first-option="defaultFirstOption"
    >
        <el-option v-for="op in _filterOptions" :key="op.value" :label="op.label" :value="op.value" :disabled="op.disabled">
            <span style="float: left; padding-right: 20px">{{ op.label }}</span>
        </el-option>
    </el-select>
    <el-select
        v-else-if="type === 'selecttree'"
        multiple
        :multiple-limit="multipleLimit"
        v-model="select_tree_names"
        :collapse-tags="collapseTags"
        :placeholder="m_placeholder('请选择')"
        :disabled="readonly"
        filterable
        :filter-method="dataFilter"
        @focus="dataFilter('')"
        @remove-tag="removetag"
        :clearable="false"
        :size="size"
        ref="selectTree"
        class="multiselect width-p100"
        :popper-append-to-body="popperAppendToBody"
    >
        <el-option :value="select_tree" class="tree-select__option" disabled>
            <el-tree
                id="tree-option"
                class="tree-select__tree tree-select__tree--checked"
                ref="tree"
                :data="_options"
                :props="defaultProps"
                :node-key="defaultProps.value"
                :accordion="true"
                show-checkbox
                check-on-click-node
                :filter-node-method="filterNode"
                :default-expand-all="true"
                :default-checked-keys="this.value"
                @check="handleNodeClick"
            ></el-tree>
        </el-option>
    </el-select>
    <el-select
        v-else-if="type === 'select1'"
        v-model="selectValue"
        filterable
        :allow-create="allowCreate"
        :placeholder="m_placeholder('请选择')"
        :disabled="readonly"
        remote
        :remote-method="filterMethod"
        @focus="filterMethod('')"
        @change="change"
        :clearable="clearable"
        :size="size"
        class="select width-p100"
    >
        <el-option v-for="op in _filterOptions" :key="op.label" :label="op.label" :value="op.value" :disabled="op.disabled">
            <span :class="{ color: op.color }" style="float: left;  padding-right: 20px">{{ op.value }}</span>
        </el-option>
    </el-select>
    <el-select
        v-else-if="type === 'selectAllowCreate'"
        v-model="selectValue"
        filterable
        :allow-create="allowCreate"
        :placeholder="m_placeholder('请选择')"
        :disabled="readonly"
        @change="change"
        :clearable="clearable"
        :size="size"
        class="select width-p100"
    >
        <el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.value">
            <span style="float: left; padding-right: 20px">{{ item.label }}</span>
        </el-option>
    </el-select>
    <el-select
        v-else-if="type === 'select_manyCos'"
        v-model="selectValue"
        filterable
        :allow-create="allowCreate"
        :placeholder="m_placeholder('请选择')"
        :disabled="readonly"
        remote
        :remote-method="filterMethod"
        @focus="filterMethod('')"
        @change="change"
        :clearable="clearable"
        :size="size"
        class="select width-p100"
    >
        <el-option v-for="op in _filterOptions" :key="op.value" :label="op.label" :value="op.value" :disabled="op.disabled">
            <div class="flexselect">
                <span>{{ op.label }}</span>
                <span style="color: #8492a6; font-size: 13px">{{ op.ownAsa }}</span>
                <span style="color: #8492a6; font-size: 13px">{{ op.code }}</span>
            </div>
        </el-option>
    </el-select>
    <el-select
        v-else-if="type == 'groupselect'"
        v-model="selectValue"
        filterable
        :placeholder="m_placeholder('请选择')"
        :disabled="readonly"
        remote
        :remote-method="filterMethod"
        @focus="filterMethod('')"
        @change="change"
        :clearable="clearable"
        :size="size"
        class="groupselect width-p100"
        :popper-append-to-body="popperAppendToBody"
    >
        <el-option-group v-for="(group, key) in _filter_group_Options" :key="key" :label="key">
            <el-option v-for="op in group" :key="op.value" :label="op.label" :value="op.value" :disabled="op.disabled">
                <span style="float: left; padding-right: 20px">{{ op.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ op.code }}</span>
            </el-option>
        </el-option-group>
    </el-select>
    <el-select
        v-else-if="type == 'multiselect'"
        multiple
        :collapse-tags="collapseTags"
        :multiple-limit="multipleLimit"
        v-model="multiSelectValue"
        :allow-create="allowCreate"
        filterable
        :disabled="readonly"
        :placeholder="m_placeholder('请选择')"
        @change="change"
        :clearable="false"
        :size="size"
        remote
        :options="_options"
        :remote-method="filterMethod"
        @focus="filterMethod('')"
        class="multiselect width-p100"
        :popper-append-to-body="popperAppendToBody"
        ref="multiselectRef"
    >
         <!-- 全选复选框 -->
        <div v-show="isShowCheckedAll">
            <el-checkbox
                v-model="checkedAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
                >
                全选
            </el-checkbox>
        </div>
        <el-option v-for="op in _filterOptions" :key="op.value" :label="op.label" :value="op.value" :disabled="op.disabled">
            <span style="float: left; padding-right: 20px">{{ op.label }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px; margin-right: 15px">{{ op.code }}</span>
        </el-option>
    </el-select>
    <el-select
        v-else-if="type == 'groupmultiselect'"
        multiple
        :collapse-tags="collapseTags"
        :multiple-limit="multipleLimit"
        v-model="multiSelectValue"
        filterable
        :disabled="readonly"
        :placeholder="m_placeholder('请选择')"
        @change="change"
        :clearable="false"
        :size="size"
        remote
        :remote-method="filterMethod"
        @focus="filterMethod('')"
        class="groupmultiselect width-p100"
        :popper-append-to-body="popperAppendToBody"
    >
        <el-option-group v-for="(group, key) in _filter_group_Options" :key="key" :label="key">
            <el-option v-for="op in group" :key="op.value" :label="op.label" :value="op.value" :disabled="op.disabled">
                <span style="float: left; padding-right: 20px">{{ op.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px; margin-right: 15px">{{ op.code }}</span>
            </el-option>
        </el-option-group>
    </el-select>
    <!-- :popper-append-to-body="popperAppendToBody" -->
    <el-select
        v-else-if="type == 'remoteselect'"
        v-model="_remoteSelectValue"
        filterable
        remote
        :collapse-tags="collapseTags"
        :placeholder="m_placeholder('请搜索')"
        @change="change"
        :clearable="clearable"
        :remote-method="remoteMethod"
        :size="size"
        :disabled="readonly"
        @focus="remoteMethod(' ')"
        class="remoteselect width-p100"
        :loading="loading"
    >
        <el-option v-for="op in _options" :key="op.value" :label="op.label" :value="op" :disabled="op.disabled">
            <el-popover ref="popover" trigger="hover" @show="showPhoto(op)">
                <el-image class="option_img" v-if="isShowPhoto && op.photo_name" slot="reference" :src="workerIcon"></el-image>
                <img style="width: 200px; height: 200px" :src="op.card_no" />
            </el-popover>
            <span style="float: left; padding-right: 20px">{{ op.label }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ op.code }}</span>
        </el-option>
    </el-select>
    <el-select
        v-else-if="type == 'remoteselecttable'"
        v-model="_remoteSelectValue"
        filterable
        remote
        :collapse-tags="collapseTags"
        :placeholder="m_placeholder('请搜索')"
        @change="change"
        :clearable="clearable"
        :remote-method="remoteMethod"
        :size="size"
        :disabled="readonly"
        @focus="remoteMethod(' ')"
        class="remoteselect width-p100"
        :loading="loading"
    >
        <el-option style="width: 800px; text-align: left" v-for="op in _options" :key="op.value" :label="op.label" :value="op" :disabled="op.disabled">
            <el-col class="selecttablelable" :span="8" :title="op.label">{{ op.label }}</el-col>
            <el-col
                class="selecttablecode"
                :span="index == op.code_list.length - 1 ? Math.floor(citem.span * (16 / op.allspan).toFixed(2)) - 1 : Math.floor(citem.span * (16 / op.allspan).toFixed(2))"
                v-for="(citem, index) in op.code_list"
                :key="`${citem}${index}`"
                :title="citem.value"
                >{{ `${citem.lable}:${citem.value}` }}</el-col
            >
        </el-option>
    </el-select>
    <table-select
        v-else-if="type == 'tableselect'"
        :value.sync="_remoteSelectValue"
        :clearable="clearable"
        :loading="loading"
        :data="_options"
        :columns="selectColumn"
        @show="tableSelectFetch(' ')"
        @filter="(value)=>tableSelectFetch(value || ' ')"
        @change="change"
    />
    <el-autocomplete
        v-else-if="type == 'autocomplete'"
        :disabled="readonly"
        :clearable="clearable"
        :readonly="false"
        :autofocus="false"
        popper-class="remoteselect width-p100"
        class="remoteselect width-p100"
        v-model="remoteAutoSelectValue"
        @select="handleSelect"
        @change="blurchange"
        :fetch-suggestions="querySearch"
    >
        <template slot-scope="{ item }">
            <span style="float: left; padding-right: 20px">{{ item.value }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
        </template>
    </el-autocomplete>
    <el-select
        v-else-if="type == 'remotemultiselect'"
        multiple
        v-model="remoteMultiSelectValue"
        :multiple-limit="multipleLimit"
        filterable
        remote
        reserve-keyword
        :collapse-tags="collapseTags"
        :placeholder="m_placeholder('请搜索')"
        @change="change"
        :clearable="false"
        :remote-method="remoteMethod"
        :size="size"
        :disabled="readonly"
        class="remotemultiselect width-p150"
        @focus="remoteMethod(' ')"
        :popper-append-to-body="popperAppendToBody"
        :loading="loading"
        ref="remotemultiselectRef"
    >
        <el-option v-for="op in _options" :key="op.value" :label="op.label" :value="op" :disabled="op.disabled">
            <span style="float: left; padding-right: 10px">{{ op.label }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px; margin-right: 10px; width: 170px; overflow: hidden">{{ op.code }}</span>
        </el-option>
    </el-select>
    <el-popover v-else-if="type == 'icons'" trigger="click" popper-class="popper-class" class="width-p100">
        <el-scrollbar style="height: 300px; position: relative">
            <el-input style="position: absolute; margin: 0; top: 0" v-model="icon_search_key" suffix-icon="el-icon-search" placeholder="请输入图标名称" :size="size"></el-input>
            <ul class="fas-icon-list">
                <li v-for="(op, index) in filterIcons" :key="index" @click="selectedIcon(op)">
                    <span style="float: left; font-size: 24px; padding-right: 20px">
                        <text-formatter type="icons" v-model="op.label"></text-formatter>
                    </span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ op.value }}</span>
                </li>
            </ul>
        </el-scrollbar>
        <el-input slot="reference" readonly v-model="textValue" style="cursor: pointer" :size="size">
            <template slot="prepend">
                <text-formatter type="icons" v-model="textValue"></text-formatter>
            </template>
        </el-input>
    </el-popover>
    <el-dropdown v-else-if="type == 'dropdown'" @command="handleCommand" trigger="click" style="width: 100%" :clearable="clearable" :size="size">
        <slot :option="dropdownValue" name="title">
            <el-button type="primary"> {{ dropdownValue && dropdownValue.label }}<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
        </slot>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="op" v-for="(op, index) in dropdownOptions" :key="index" style="min-width: 140px">
                <slot :option="op">{{ op.label }}</slot>
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
    <el-checkbox-group v-else-if="type == 'checkboxgroup'" v-model="listValue" @change="change" :size="size" class="width-p100">
        <el-checkbox :border="borderd" :disabled="readonly" :label="op.value" v-for="op in _options" :key="op.value">{{ op.label }}</el-checkbox>
    </el-checkbox-group>
    <el-checkbox :border="borderd" :disabled="readonly" v-else-if="type == 'checkbox'" v-model="checked" @change="change">
        <slot>{{ placeholder }}</slot>
    </el-checkbox>
    <el-radio-group v-else-if="type == 'radio'" v-model="selectValue" @change="change" :size="size" class="width-p100">
        <el-radio :border="borderd" :label="op.value" v-for="op in _options" :key="op.value" :title="op.label">{{ op.label }}</el-radio>
    </el-radio-group>
    <div v-else-if="type == 'bool'" style="line-height: 32px; color: darkgray; display: inline-block">
        <el-switch v-model="checked" :active-color="themeColor" :size="size" @change="change" :disabled="readonly"></el-switch>
        <!-- {{checked?_bool_options.t&&_bool_options.t.label:_bool_options.f&&_bool_options.f.label }} -->
    </div>
    <div v-else-if="type == 'rbool'" style="line-height: 32px; color: darkgray; display: inline-block">
        <el-switch v-model="checked" :active-color="themeColor" @change="change" :disabled="readonly"></el-switch>
        <!-- {{!checked?_bool_options.t&&_bool_options.t.label:_bool_options.f&&_bool_options.f.label }} -->
    </div>
    <el-date-picker
        v-else-if="type == 'hhdatetime'"
        v-model="dateValue"
        :size="size"
        :disabled="readonly"
        :editable="editable"
        :value-format="datetimeFormate"
        :format="showFormate"
        type="datetime"
        class="datetime"
        :class="{ 'none-padding': noPadding }"
        :placeholder="m_placeholder('日期时间')"
        default-time="12:00:00"
        @input="change"
        clearable
        style="width: 100%"
    >
    </el-date-picker>
    <el-date-picker
        v-else-if="type == 'datetime'"
        v-model="dateValue"
        :size="size"
        :disabled="readonly"
        :editable="editable"
        :value-format="datetimeFormate"
        :format="datetimeFormate"
        type="datetime"
        class="datetime"
        :class="{ 'none-padding': noPadding }"
        :placeholder="m_placeholder('日期时间')"
        default-time="12:00:00"
        @input="change"
        clearable
        style="width: 100%"
    >
    </el-date-picker>
    <input v-else-if="type == 'datetime-local'" class="inputlocal" v-model="localdatevalue" type="datetime-local" name="points" max="2299-01-01T23:59" @blur="change2" />
    <el-date-picker
        v-else-if="type == 'month'"
        v-model="dateValue"
        :size="size"
        :disabled="readonly"
        :editable="editable"
        value-format="yyyy/MM"
        :format="datetimeFormate"
        type="month"
        class="month"
        :class="{ 'none-padding': noPadding }"
        :placeholder="m_placeholder('日期月')"
        @input="change"
        clearable
        style="width: 100%"
    >
    </el-date-picker>
    <el-date-picker
        v-else-if="type == 'date'"
        v-model="dateValue"
        :size="size"
        :disabled="readonly"
        :editable="editable"
        :value-format="dateFormate"
        :format="dateFormate"
        type="date"
        class="date"
        :class="{ 'none-padding': noPadding }"
        :placeholder="m_placeholder('日期')"
        @input="change"
        :clearable="false"
        style="width: 100%"
    >
    </el-date-picker>
    <el-row type="flex" align="center" v-else-if="type == 'datearraw'" class="datearraw" style="background: inherit; padding: 0 5px; height: 40px">
        <el-col :span="4" style="display: flex; align-items: center; height: 100%">
            <el-button icon="el-icon-back" circle @click="addDay(-1)" :size="size"></el-button>
        </el-col>
        <el-col :span="16" style="display: flex; align-items: center; height: 100%">
            <el-date-picker
                v-model="dateValue"
                style="width: 100%"
                :size="size"
                :editable="editable"
                :value-format="dateFormate"
                :class="{ 'none-padding': noPadding }"
                :format="dateFormate"
                type="date"
                :placeholder="m_placeholder('日期')"
                :clearable="false"
                @input="change"
            >
            </el-date-picker>
        </el-col>
        <el-col :span="4" style="display: flex; align-items: center; justify-content: flex-end; height: 100%">
            <el-button icon="el-icon-right" circle @click="addDay(1)" :size="size"></el-button>
        </el-col>
    </el-row>
    <el-row v-else-if="type == 'datearraw2'" class="datearraw2" type="flex" align="center" style="padding: 0 5px; height: 40px">
        <el-col :span="4" style="display: flex; align-items: center; height: 100%">
            <el-button icon="el-icon-back" type="primary" plain circle @click="addDay(-1)" :size="size" style="padding: 5px !important"></el-button>
        </el-col>
        <el-col :span="16" class="padding5 padding-none-v" style="display: flex; align-items: center; height: 100%">
            <el-date-picker
                v-model="dateValue"
                style="width: 100%"
                :size="size"
                :value-format="dateFormate"
                prefix-icon=""
                :editable="editable"
                :format="dateFormate"
                type="date"
                :placeholder="m_placeholder('日期')"
                :clearable="false"
                @input="change"
            >
            </el-date-picker>
        </el-col>
        <el-col :span="4" style="display: flex; align-items: center; justify-content: flex-end; height: 100%">
            <el-button icon="el-icon-right" type="primary" plain circle @click="addDay(1)" :size="size" style="padding: 5px !important"></el-button>
        </el-col>
    </el-row>
    <el-time-picker
        v-model="timeValue"
        v-else-if="type == 'time'"
        style="width: 120px; background: inherit; padding: 0 5px; float: left"
        :size="size"
        value-format="HH:mm"
        format="HH:mm"
        :disabled="readonly"
        :picker-options="{
            selectableRange: '00:00:00 - 23:59:59'
        }"
        :placeholder="m_placeholder('时间')"
        @input="change"
    >
    </el-time-picker>
    <el-date-picker
        v-else-if="type == 'daterange'"
        v-model="dateRangeValue"
        :size="size"
        class="daterange"
        style="width: 100%"
        type="daterange"
        :editable="true"
        :clearable="true"
        :disabled="readonly"
        :class="{ 'none-padding': noPadding }"
        :picker-options="pickerOptions"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @input="change"
    >
    </el-date-picker>
    <el-date-picker v-else-if="type == 'datetimerange'" v-model="dateRangeValue" :size="size" class="daterange"
        value-format="yyyy/MM/dd HH:mm" format="yyyy/MM/dd HH:mm" style="width: 100%" type="datetimerange" :editable="true"
        :clearable="true" :disabled="readonly" :class="{ 'none-padding': noPadding }" :picker-options="pickerOptions"
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @input="change">
    </el-date-picker>
    <div v-else-if="type == 'buttongroup'" :style="{  display: 'flex', 'align-items': 'center', 'justify-content': `${this.align}`, padding: '0 5px' }">
        <el-tooltip v-for="(op, index) in _btn_options" :key="index" :disabled="!op.tooltip" class="item" effect="light" :content="op.tooltip" placement="bottom">
            <component
                :is="op.tag || 'el-button'"
                :class="[op.class, op.emit]"
                :type="op.type"
                size="mini"
                v-has-permission="op.permission"
                @click.stop="$emit('extrabutton-click', { emit: op.emit, op: op })"
            >
                <TextFormatter v-if="op.icon" type="icons" v-model="op.icon"></TextFormatter>
                {{ op.label }}
            </component>
        </el-tooltip>
        <!-- <component :is="op.tag||'el-button'" v-for="(op,index) in _btn_options"
                  :class="[op.class,op.emit]"
                  :type="op.type" size="mini" v-has-permission="op.permission"
                :key="index" @click.stop="$emit('extrabutton-click',{emit:op.emit})">
                <TextFormatter v-if='op.icon' type='icons' v-model="op.icon"></TextFormatter>
                {{op.label}}
      </component> -->
    </div>
    <div v-else-if="type == 'table'" style="width: 100%">
        <el-row>
            <el-col :xl="23" :lg="22" :md="21">{{ placeholder }}</el-col>
            <el-col :xl="1" :lg="2" :md="3" class="align-right">
                <el-button type="primary" :size="size" plain @click="addRow()"><i class="el-icon-plus"></i>添加</el-button>
            </el-col>
        </el-row>
        <list-view
            ref="table1"
            :showSequence="showSequence"
            :selection="selection"
            :datalist="tablerows"
            :tableHeight="tableHeight"
            :columns="_table_columns"
            :buttons="tableButtons"
            @extrabutton-click="ExtraButtonClick"
        ></list-view>
    </div>
    <div v-else-if="type == 'table2'" style="width: 100%">
        <list-view :spanMethod="spanMethod" :showSequence="showSequence" :selection="selection" :datalist="tablerows" :tableHeight="tableHeight" :columns="_table_columns" @extrabutton-click="ExtraButtonClick"></list-view>
    </div>
    <div v-else-if="type == 'itemgroup'" style="width: 100%; float: left; height: 38px">
        <item-group :labelPosition="labelPosition" :data="value" :columns="_options" @extrabutton-click="ExtraButtonClick" @change="change"></item-group>
    </div>
    <p v-else-if="type == 'p'" style="width: 100%; float: left; margin: 0; line-height: 40px">{{ value || placeholder }}</p>
    <el-divider v-else-if="type == 'divider'" content-position="center">{{ value || placeholder }}</el-divider>
    <el-color-picker v-else-if="type == 'colorpicker'" v-model="color" color-format="rgb" :predefine="predefineColors" @input="change"> </el-color-picker>
    <el-popover v-else-if="type == 'imgicon'" trigger="click" popper-class="popper-class">
        <el-scrollbar style="height: 300px; position: relative">
            <!-- <el-input style="position:absolute;margin: 0;top: 0;" v-model="icon_search_key"  suffix-icon="el-icon-search" placeholder="请输入图标名称" :size="size"></el-input> -->
            <ul class="fas-icon-list" style="margin-top: 0">
                <li v-for="(op, index) in filterIcons" :key="index" @click="selectedIcon(op)">
                    <img :src="op.code" style="height: 24px" />
                    <span style="float: right; color: #8492a6; font-size: 13px; line-height: 24px">{{ op.label }}</span>
                </li>
            </ul>
        </el-scrollbar>
        <el-input slot="reference" readonly v-model="textValue" style="cursor: pointer" :size="size" placeholder="请选择">
            <template slot="prepend">
                <img :src="imgiconsrc" style="height: 60%" />
            </template>
        </el-input>
    </el-popover>
    <el-upload
        v-else-if="type == 'upload'"
        :action="options"
        :list-type="listType"
        :multiple="multiple"
        :limit="multipleLimit"
        :accept="accept"
        :on-remove="_removefile"
        :on-error="_uploadError"
        :on-exceed="exceed"
        :on-success="handleFileSuccess"
        :before-upload="_beforeUpload"
        :headers="{ Authorization: `bearer ${token}` }"
        :file-list="fileList"
    >
        <i slot="default" class="el-icon-plus cus-button is-circle"></i>
        <div slot="tip" class="el-upload__tip">{{ placeholder }}</div>
    </el-upload>
</template>
<script>
import TableSelect from '@/common/TableSelect'
export default {
    name: `ItemInput`,
    components: {
        TableSelect
    },
    props: {
        value: { type: Array | String | Number | Object },
        placeholder: { type: String },
        type: { type: String },
        pname: { type: String },
        clearable: { type: Boolean, default: false },
        options: { type: Array | String | Function, default: () => [] },
        readonly: { type: Boolean, default: false },
        editable: { type: Boolean, default: false },
        collapseTags: { type: Boolean, default: true },
        selection: { type: Boolean, default: false },
        showSequence: { type: Boolean, default: true },
        spanMethod: { type: Function },
        labelPosition: { type: String },
        size: { type: String, default: `small` },
        multipleLimit: { type: Number, default: 0 },
        bodyClass: { type: String, default: `` },
        minRows: { type: Number, default: 1 },
        maxRows: { type: Number, default: 4 },
        showFormate: { type: String, default: `yyyy/MM/dd HH:mm` },
        datetimeFormate: { type: String, default: `yyyy/MM/dd HH:mm` },
        borderd: { type: Boolean, default: false },
        autofocus: { type: Boolean, default: false },
        multiple: { type: Boolean, default: true },
        onExceed: { type: Function },
        onFileSuccess: { type: Function },
        beforeUpload: { type: Function },
        accept: { type: String },
        removeFile: { type: Function },
        listType: { type: String, default: `picture-card` },
        popperAppendToBody: { type: Boolean, default: true },
        defaultFirstOption: { type: Boolean, default: true },
        height: { type: Number | String },
        noPadding: { type: Boolean, default: false },
        align: { type: String, default: `center` },
        allowCreate: { type: Boolean, default: false },
        showCount: { type: Number, default: 1 },
        isShowPhoto: { type: Boolean, default: false },
        isShowCamera: { type: Boolean, default: false },
        slotValue: { type: String, default: null },
        decimal_places: { type: Number, default: 3 },
        selectColumn: { type: Array },
        isShowCheckedAll: { type: Boolean, default: false }

    },
    data() {
        const countDom = document.createElement(`span`)
        countDom.classList = [`count-node`]
        let obj = this
        return {
            countDom,
            _datevalue: ``,
            _localdatevalue: ``,
            _timevalue: ``,
            _textValue: ``,
            _numberValue: ``,
            _listValue: [],
            _checked: false,
            _dropdownvalue: null,
            _color: ``,
            dateFormate: `yyyy/MM/dd`,
            icon_search_key: ``,
            loading: false,
            remoteList: [],
            autooptionsList: [],
            selectOption: [],
            remoteUrl: ``,
            searchKey: ``,
            _remoteMultiSelectValue: [],
            remoteSelectValue: ``,
            remoteAutoSelectValue: this.value,
            _tablerows: [],
            tableButtons: [
                {
                    label: `删除`,
                    icon: `el-icon-delete`,
                    type: `danger`,
                    emit: `removeRow`,
                    permission: `default`
                }
            ],
            predefineColors: [`#ff4500`, `#ff8c00`, `#ffd700`, `#90ee90`, `#00ced1`, `#1e90ff`, `#c71585`, `rgb(255, 120, 0)`, `hsv(51, 100, 98)`, `hsl(181, 100%, 37%)`],
            _filelist: [],
            scan_val: ``,
            workerIcon: `../../static/img/avatar/default/surgeon_photo.png`,
            pickerOptions: {
                shortcuts: [{
                    text: `昨天`,
                    onClick(picker) {
                        const start = new Date()
                        const end = new Date()
                        start.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
                        picker.$emit(`pick`, [start, end])
                    }
                }, {
                    text: `今天`,
                    onClick(picker) {
                        const start = new Date()
                        const end = new Date()
                        picker.$emit(`pick`, [start, end])
                    }
                }, {
                    text: `明天`,
                    onClick(picker) {
                        const start = new Date()
                        const end = new Date()
                        start.setTime(end.getTime() + 3600 * 1000 * 24 * 1)
                        picker.$emit(`pick`, [start, start])
                    }
                }, {
                    text: `前一周`,
                    onClick(picker) {
                        const start = new Date()
                        const end = new Date()
                        start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
                        picker.$emit(`pick`, [start, end])
                    }
                }, {
                    text: `前一月`,
                    onClick(picker) {
                        const start = new Date()
                        const end = new Date()
                        start.setTime(end.getTime() - 3600 * 1000 * 24 * 30)
                        picker.$emit(`pick`, [start, end])
                    }
                }, {
                    text: `前三月`,
                    onClick(picker) {
                        const start = new Date()
                        const end = new Date()
                        start.setTime(end.getTime() - 3600 * 1000 * 24 * 90)
                        picker.$emit(`pick`, [start, end])
                    }
                }, {
                    text: `前一季`,
                    onClick(picker) {
                        let date = obj.getLastQuarter()
                        picker.$emit(`pick`, [date.startDate, date.endDate])
                    }
                }, {
                    text: `前一年`,
                    onClick(picker) {
                        let date = obj.getLastYear()
                        picker.$emit(`pick`, [date.startDate, date.endDate])
                    }
                }]
            },
            scanActive: true,
            tmp_select_tree_names: [],
            select_tree: [],
            defaultProps: {
                value: `value`,
                children: `children`,
                label: `label`,
                parentValue: `parent_value`
            },
            checkedAll: false
            // oldInputNode: null,
            // remote_keyword:''
        }
    },
    directives: {
        focus: {
            // 指令的定义
            inserted: function(el, { value }) {
                if (value) {
                    let $input = el.getElementsByTagName(`input`)[0]
                    $input && $input.focus()
                }
            }
        }
    },
    // updated(){
    //   if(this.$refs.table1){
    //     let $scroller = this.$refs.table1.$refs["cus-table"].bodyWrapper
    //     $scroller.scrollTop=($scroller.scrollHeight+1000)
    //   }
    // },
    computed: {
        themeColor() {
            return getComputedStyle(document.documentElement).getPropertyValue(`--primary-color`).trim() || `#009688`
        },
        isIndeterminate() {
            if (this.multiSelectValue && this.multiSelectValue.length === 0) return false // 没有选中任何项时不是不确定状态
            if (this.multiSelectValue && this.multiSelectValue.length === this._options.length) return false // 全选时不是不确定状态
            return true // 其他情况为不确定状态
        },
        tableHeight() {
            return this.height
        },
        token() {
            return sessionStorage.getItem(`token`)
        },
        dropdownOptions() {
            let that = this
            return _.filter(that._options, d => {
                return d.value != that.value
            })
        },
        _options() {
            let r = []
            if (this.options && this.type != `remoteselect` && this.type != `remotemultiselect` && this.type != `remoteselecttable` && this.type != `tableselect`) {
                r = _.isArray(this.options) ? this.options : this.$store.getters[this.options]
                if (this.type == `multiselect` && this.value && this.value.length > 0) {
                    let selectedItem = _.filter(r, c => {
                        return _.includes(this.value, c.value)
                    })
                    r = _.differenceBy(r, selectedItem, `value`)
                    r = selectedItem.concat(r)
                }
            } else if (this.type == `remoteselect` || this.type == `remotemultiselect` || this.type == `remoteselecttable` || this.type == `tableselect`) {
                // if(_.isArray(this.options)) {return this.options}
                this.remoteUrl = this.options
                r = (this.remoteList.length > 0 && this.remoteList) || this.selectOption
                // let ops = _.take(this.remoteList,50)
                // ops = _.differenceBy(ops,this.selectOption,'value')
                // return this.selectOption.concat(ops)
            }

            if (r && r[0] && _.has(r[0], `disabled`)) {
                r = _.orderBy(r, `disabled`)
            }
            return r
        },
        _autooptions() {
            let r = []
            if (this.type == `autocomplete`) {
                this.remoteUrl = this.options
                r = (this.autooptionsList.length > 0 && this.autooptionsList) || this.selectOption
            }
            if (r && r[0] && _.has(r[0], `disabled`)) {
                r = _.orderBy(r, `disabled`)
            }

            return _.map(r, d => {
                return {
                    value: d.label,
                    id: d.value,
                    code: d.code,
                    jianpin: d.jianpin,
                    alias: d.alias
                }
            })
        },
        _filterOptions() {
            let r = this._options
            if (this.searchKey) {
                let k = this.searchKey.toUpperCase()
                return _.filter(r, op => {
                    return _.includes(op.label.toUpperCase(), k) || _.includes(op.jianpin, k) || _.includes(op.card_no, k)
                })
            }
            // 注释这行，原因：初始化下拉框的时候如果只50条的话，之前选的非本次50条外的 全部会显示成ID  jira:ACIS-22512
            // let s = _.take(r, 50)
            return r
        },
        _filter_group_Options() {
            let r = _.groupBy(this._filterOptions, `group`)
            return r
        },
        _btn_options() {
            let chks = []
            if (_.isString(this.value)) {
                chks = this.value.split(`,`)
            } else {
                chks = this.value
            }
            if (!chks || chks.length == 0) return this._options
            return _.filter(this._options, (op, index) => {
                return _.includes(chks, index)
            })
        },
        _table_columns() {
            return this._options.concat({
                type: `string`,
                prop: `___index`,
                label: `___index`,
                isKey: true
            })
        },
        // _bool_options(){
        //   let  t  = _.find(this._options,{value:true})
        //   let  f  = _.find(this._options,{value:false})
        //   return {t,f}
        // },
        color: {
            get: function() {
                this._color = this.value === undefined ? null : `rgb(${this.value})`
                return this._color
            },
            set: function(newColor) {
                this._color = newColor.replace(/rgb\(/, ``).replace(/\)/, ``)
            }
        },
        textValue: {
            get: function() {
                this._textValue = this.value
                return this._textValue
            },
            set: function(newval) {
                this._textValue = newval
            }
        },
        selectValue: {
            get: function() {
                // debugger
                // var regPos = /^\d+$/ // 非负整数
                // this._textValue = regPos.test(this.value) ? parseInt(this.value) : this.value
                if (this._filterOptions && this._filterOptions.length > 0) {
                    this._textValue = typeof this._filterOptions[0].value == `number` && this.value ? parseInt(this.value) : this.value
                } else {
                    this._textValue = this.value
                }
                return this._textValue
            },
            set: function(newval) {
                this._textValue = newval
                // this._textValue = newval.value
            }
        },
        multiSelectValue: {
            get: function() {
                this._multiSelectValue = this.value
                return this._multiSelectValue
            },
            set: function(newval) {
                this._multiSelectValue = newval
            }
        },
        select_tree_names: {
            get: function() {
                if (this.value && this.value.length > 0) {
                    this.tmp_select_tree_names = []
                    _.forEach(this.value, op => {
                        let selectItem = _.find(this.select_tree, { value: op })
                        if (selectItem && selectItem.label) {
                            if (!this.tmp_select_tree_names.includes(selectItem.label)) {
                                this.tmp_select_tree_names.push(selectItem.label)
                            }
                        }
                    })
                }
                return this.tmp_select_tree_names || []
            },
            set: function(newval) {
                this.tmp_select_tree_names = newval
            }
        },
        remoteMultiSelectValue: {
            get: function() {
                if (this.value && this.value.length > 0) {
                    // 初始赋值，需要给出完整的options
                    this._remoteMultiSelectValue = []
                    _.forEach(this.value, op => {
                        if (_.has(op, `value`)) {
                            this._remoteMultiSelectValue.push(op)
                            if (_.findIndex(this.selectOption, { value: op.value }) == -1) {
                                this.selectOption.push({ ...op })
                            } else {
                                let selected = _.find(this.selectOption, { value: op.value })
                                if (_.has(op, `label`) && op.label != selected.label) {
                                    selected.label = op.label
                                }
                            }
                        } else {
                            // 非option对象赋值
                            this._remoteMultiSelectValue.push(op)
                        }
                    })
                } else {
                    this._remoteMultiSelectValue = []
                }
                return this._remoteMultiSelectValue
            },
            set: function(newval) {
                // newval=newval||[]
                // let oldval=this.selectOption||[]
                // if(newval.length>oldval.length){
                //   let newvalue = _.differenceWith(newval,oldval,function(arrVal, othVal){
                //     return arrVal.value == othVal.value
                //   })[0]
                //   this.selectOption.push(newvalue)
                // }
                this._remoteMultiSelectValue = newval
            }
        },
        _remoteSelectValue: {
            get: function() {
                if (_.has(this.value, `value`)) {
                    let index = _.findIndex(this.selectOption, { value: this.value.value })
                    if (index < 0) {
                        this.selectOption.push({ value: this.value.value, label: this.value.label })
                    }
                    this.remoteSelectValue = this.value
                } else {
                    this.remoteSelectValue = this.value
                }
                return this.remoteSelectValue
            },
            set: function(newval) {
                this.remoteSelectValue = newval
            }
        },
        _remoteAutoSelectValue: {
            get: function() {
                // this.selectOption = []
                // let index = _.findIndex(this.selectOption, { value: this.value })

                // if (index < 0) {
                //     alert(index)
                //     this.selectOption.push({ value: this.value, label: this.value })
                // }
                this.remoteAutoSelectValue = this.value
                return this.remoteAutoSelectValue
            },
            set: function(newval) {
                this.remoteAutoSelectValue = newval
            }
        },
        dateRangeValue: {
            get: function() {
                if (_.isArray(this.value) && this.value.length == 2) {
                    this._datevalue = this.value.map(v => {
                        let d = this.$moment(v)
                        if (d.isValid() && v) {
                            return d.format(`YYYY/MM/DD HH:mm`)
                        } else {
                            return ``
                        }
                    })
                } else {
                    this._datevalue = [``, ``]
                }
                return this._datevalue
            },
            set: function(newval) {
                this._datevalue = newval
            }
        },
        dateValue: {
            get: function() {
                let d = this.$moment(this.value)
                if (d.isValid() && this.value) {
                    switch (this.datetimeFormate) {
                    case `yyyy/MM`:
                        this._datevalue = d.format(`YYYY/MM`)
                        break
                    case `yyyy/MM/dd HH:mm:ss`:
                        this._datevalue = d.format(`YYYY/MM/DD HH:mm:ss`)
                        break
                    case `yyyy/MM/dd HH:mm`:
                        this._datevalue = d.format(`YYYY/MM/DD HH:mm`)
                        break
                    default:
                        this._datevalue = d.format(`YYYY/MM/DD HH:mm`)
                        break
                    }
                } else {
                    this._datevalue = ``
                }
                return this._datevalue
            },
            set: function(newval) {
                this._datevalue = newval
            }
        },
        localdatevalue: {
            get: function() {
                let d = this.$moment(this.value)
                if (d.isValid() && this.value) {
                    let rd = this.timeForm(this.value)
                    this._localdatevalue = rd
                } else {
                    this._localdatevalue = ``
                }
                return this._localdatevalue
            },
            set: function(newval) {
                this._localdatevalue = newval
            }
        },
        timeValue: {
            get: function() {
                let d = this.$moment(this.value)
                if (d.isValid() && this.value) {
                    this._timevalue = d.format(`HH:mm`)
                } else {
                    this._timevalue = ``
                }
                return this._timevalue
            },
            set: function(newval) {
                this._timevalue = newval
            }
        },
        numberValue: {
            get: function() {
                if (this.value == `0`) {
                    this._numberValue = `0`
                } else if (this.value) {
                    let r = (this.value && `${this.value}`) || ``
                    let pre = ``
                    if (_.startsWith(r, `-`) && (this.type == `float` || this.type == `integer1`)) {
                        pre = `-`
                    }
                    if (!_.startsWith(r, `0.`) && r.length >= 2) {
                        r = _.trimStart(r, `0`)
                    }
                    if (r.indexOf(`.`) > -1) {
                        let nums = this.decimal_places || 3
                        r = r.substr(0, r.indexOf(`.`) + nums + 1) // 最多3位小数
                    }
                    r = this.type == `float` ? r.replace(/[^\d.]/g, ``) : r.replace(/[^\d]/g, ``)
                    if (this.type == `number` && parseInt(r) < 1) {
                        // 最小值为1
                        r = `1`
                    }
                    this._numberValue = pre + r
                } else {
                    this._numberValue = ``
                }
                return this._numberValue
            },
            set: function(newval, oldval) {
                if (newval == `0`) {
                    this._numberValue = `0`
                } else if (newval.length > 0) {
                    let r = newval
                    let pre = ``
                    if (_.startsWith(r, `-`) && (this.type == `float` || this.type == `integer1`)) {
                        pre = `-`
                    }
                    if (!_.startsWith(r, `0.`) && r.length >= 2) {
                        r = _.trimStart(r, `0`)
                    }
                    if (r.indexOf(`.`) > -1) {
                        let nums = this.decimal_places || 3
                        r = r.substr(0, r.indexOf(`.`) + nums + 1) // 最多3位小数
                    }
                    r = this.type == `float` ? r.replace(/[^\d.]/g, ``) : r.replace(/[^\d]/g, ``)
                    if (this.type == `number` && parseInt(r) < 1) {
                        // 最小值为1
                        r = `1`
                    }
                    this._numberValue = pre + r
                } else {
                    this._numberValue = ``
                }
            }
        },
        listValue: {
            get: function() {
                this._listValue = this.type == `checkboxgroup` ? (this.value && this.value.toString().split(`,`)) || [] : this.value
                return this._listValue
            },
            set: function(newval) {
                this._listValue = newval
            }
        },
        checked: {
            get: function() {
                if (this.type == `bool`) return this.value == true
                if (this.type == `rbool`) return this.value == false // rbool在入口和出口对 bool意义转换,rbool只在空间内部生效
                this._checked = this.value
                return this._checked
            },
            set: function(newval) {
                this._checked = newval
            }
        },
        dropdownValue: {
            get: function() {
                return this.type == `dropdown` ? _.find(this._options, { value: this.value }) : { label: `--`, value: undefined }
            }
        },
        filterIcons() {
            let that = this
            if (_.trim(that.icon_search_key).length == 0) {
                return that._options
            }
            return _.filter(this._options, op => {
                return _.includes(op.label, that.icon_search_key)
            })
        },
        tablerows: {
            get() {
                if (this.value && _.isArray(this.value)) {
                    let fn = _.now()
                    this._tablerows = this.value.map((v, index) => {
                        // let r ={...v}
                        v.___index = v.___index || `${fn}_${index}`
                        return v
                    })
                } else {
                    this._tablerows = []
                }
                return this._tablerows
            }
        },
        imgiconsrc() {
            let r = _.find(this.options, { value: this.value })
            return (r && r.code) || ``
        },
        fileList: {
            get: function() {
                this._filelist = this.value || []
                return this._filelist
            },
            set: function(newval) {
                this._filelist = newval
            }
        },
        isMobile() {
            // 判断是否是移动端
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag
        }
    },
    methods: {
        handleCheckAllChange(val) {
            let selectInfo = this.checkedAll ? this._options.map(item => item.value) : []
            this.$emit(`input`, selectInfo)
            this.checkedAll = val // 更新全选状态
        },
        getThisQuarter() {
            const today = new Date()
            const month = today.getMonth() + 1
            const quarter = Math.ceil(month / 3)
            const year = today.getFullYear()
            let startDate = null
            let endDate = null
            if (quarter == 1) {
                startDate = new Date(year, 0, 1)
                endDate = new Date(year, 2, 31)
            } else if (quarter == 2) {
                startDate = new Date(year, 3, 1)
                endDate = new Date(year, 5, 30)
            } else if (quarter == 3) {
                startDate = new Date(year, 6, 1)
                endDate = new Date(year, 8, 30)
            } else if (quarter == 4) {
                startDate = new Date(year, 9, 1)
                endDate = new Date(year, 11, 31)
            }
            return {
                startDate: startDate.toLocaleDateString(),
                endDate: endDate.toLocaleDateString()
            }
        },
        getLastQuarter() {
            let thisQuarter = this.getThisQuarter()
            let startDate = new Date(new Date(thisQuarter.startDate).setMonth(new Date(thisQuarter.startDate).getMonth() - 3))
            let endDate = new Date(new Date(thisQuarter.endDate).setMonth(new Date(thisQuarter.endDate).getMonth() - 3))
            return {
                startDate: startDate.toLocaleDateString(),
                endDate: endDate.toLocaleDateString()
            }
        },
        getLastYear() {
            const today = new Date()
            const startDate = today.getFullYear() - 1 + `/1/1`
            const endDate = today.getFullYear() - 1 + `/12/31`
            return {
                startDate: startDate,
                endDate: endDate
            }
        },
        flatten(arr) {
            let ops = _.cloneDeep(arr)
            return [].concat(...ops.map(item => {
                if (item.children) {
                    let ops = [].concat(item, ...this.flatten(item.children))
                    delete item.children
                    return ops
                }
                return [].concat(item)
            }
            ))
        },
        // selecttree控件 check 发生变化时触发
        handleNodeClick(node, self, child) {
            let that = this
            let datalist = this.$refs.tree.getCheckedNodes()
            datalist = datalist.filter(v => v[that.defaultProps.parentValue])
            that.select_tree = datalist
            // eslint-disable-next-line camelcase
            let select_tree_values = datalist.map(p => p.value)
            that.select_tree_names = datalist.map(p => p.label)
            // // 提交form表单值
            this.$emit(`input`, select_tree_values)
        },
        // 删除选中的tag标记时触发
        removetag(tagName) {
            this.selectTree = this.select_tree.filter(v => v[this.defaultProps.label] !== tagName)
            let selectTreeValue = this.selectTree.map(v => v[this.defaultProps.value])
            let setlist = this.$refs.tree.getCheckedNodes()
            setlist = setlist.filter(v => v[this.defaultProps.value] === selectTreeValue.find(item => item === v[this.defaultProps.value]))
            this.$nextTick(() => {
                this.$refs.tree.setCheckedNodes(setlist)
            })
            // eslint-disable-next-line camelcase
            let select_tree_values = setlist && setlist.map(p => p.value)
            this.$emit(`input`, select_tree_values)
        },
        clearall() {
            this.selectTree = []
            this.$nextTick(() => {
                this.$refs.tree.setCheckedNodes([])
            })
        },
        // selectTreeValue 发生变化，是否大于showCount，样式处理
        selectTreeValueChanged() {
            this.countDom.style.display = `none`
            this.countDom.innerHTML = ``
            if (!this.value || this.value.length == 0) {
                return
            }
            if (this.value.length <= this.showCount) {
                this.$nextTick(() => {
                    let awaitUntilEqual = () => {
                        if (!this.$refs.selectTree || !this.$refs.selectTree.$el) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        let elTags = this.$refs.selectTree.$el.querySelectorAll(`.el-tag`)
                        if (elTags.length != this.value.length) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        elTags.forEach((elTag, index) => {
                            elTag.style.display = `inline-block`
                        })
                    }
                    awaitUntilEqual()
                })
            } else {
                this.countDom.style.display = `inline-block`
                this.countDom.innerHTML = `+ ` + (this.value.length - this.showCount)
                this.$nextTick(() => {
                    let awaitUntilEqual = () => {
                        if (!this.$refs.selectTree || !this.$refs.selectTree.$el) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        let elTags = this.$refs.selectTree.$el.querySelectorAll(`.el-tag`)
                        if (elTags.length != this.value.length) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        elTags.forEach((elTag, index) => {
                            if (index >= this.showCount) {
                                elTag.style.display = `none`
                            } else {
                                elTag.style.display = `inline-block`
                            }
                        })
                    }
                    awaitUntilEqual()
                })
            }
        },
        selectTreeCountDom() {
            if (this.$refs.selectTree && this.$refs.selectTree.$el) {
                let span = this.$refs.selectTree.$el.querySelector(`.el-select__tags > span`)
                let input = this.$refs.selectTree.$el.querySelector(`.el-select__tags > input`)
                if (span) {
                    span.after(this.countDom)
                } else if (input) {
                    input.after(this.countDom)
                }
            } else {
                this.$nextTick(() => {
                    if (this.$refs.selectTree && this.$refs.selectTree.$el) {
                        let span = this.$refs.selectTree.$el.querySelector(`.el-select__tags > span`)
                        let input = this.$refs.selectTree.$el.querySelector(`.el-select__tags > input`)
                        if (span) {
                            span.after(this.countDom)
                        } else if (input) {
                            input.after(this.countDom)
                        }
                    }
                })
            }
        },
        setscanActive() {
            setTimeout(() => {
                this.scanActive = true
            }, 2000)
        },
        openScan() {
            let that = this
            this.scanActive = false
            this.setscanActive()
            if (!this.isShowCamera) {
                // 摄像头扫码
                // 存在cordova在打开
                // eslint-disable-next-line no-undef
                if (typeof cordova != `undefined`) {
                    // eslint-disable-next-line no-undef
                    cordova.plugins.barcodeScanner.scan(
                        function(result) {
                            that.scan_val = result.text
                            that.$children[0] && that.$children[0].$children[0] && that.$children[0].$children[0].doClose()
                            that.enter()
                        },
                        function(error) {
                            that.$alert(`扫码失败:` + error, `提醒`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                        },
                        {
                            preferFrontCamera: false, // iOS and Android
                            showFlipCameraButton: true, // iOS and Android
                            showTorchButton: true, // iOS and Android
                            torchOn: false, // Android, launch with the torch switched on (if available)
                            saveHistory: true, // Android, save scan history (default false)
                            prompt: `请扫描二维码`, // Android
                            resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                            // formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                            orientation: `portrait`, // Android only (portrait|landscape), default unset so it rotates with the device
                            disableAnimations: true, // iOS
                            disableSuccessBeep: false // iOS and Android
                        }
                    )
                } else {
                    that.$alert(`cordova为NULL，无法扫码！`, `提醒`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    })
                }
            } else {
                // 打开扫描头 扫码
                if (window.broadcaster) {
                    window.broadcaster.fireNativeEvent(`com.scan.onStartScan`, {}, false, function(data) {}, function(e) {})
                }
            }
        },
        showPhoto(row) {
            if (row.photo_name) {
                row.card_no = `${this.$root.BASE_URL}api/AcisSystem/Worker/GetPictureFile/${row.value}?fileName=${row.photo_name}`
            } else {
                row.card_no = this.workerIcon
            }
        },
        querySearch(queryString, cb) {
            let that = this
            this.loading = true
            this.remote_keyword = queryString
            let promise
            let q = {}
            if (_.trim(this.remote_keyword).length > 0) {
                q.keyword = _.trim(this.remote_keyword)
            }
            this.remoteUrl = this.options
            promise = Promise.resolve(this.remoteUrl(q))
            promise
                .then(data => {
                    that.loading = false
                    let ops = data
                    ops = _.differenceBy(ops, that.selectOption, `label`)
                    // return this.selectOption.concat(ops)
                    this.autooptionsList = that.selectOption.concat(ops)
                    let r = this._autooptions
                    var results = queryString ? r.filter(this.createFilter(queryString)) : r
                    // 调用 callback 返回建议列表的数据
                    cb(results)
                })
                .catch(res => {
                    console.error(`load data faild.`, res)
                    this.loading = false
                })
        },
        createFilter(queryString) {
            return textValue => {
                return textValue.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1 ||
                (textValue.jianpin && textValue.jianpin.toLowerCase().indexOf(queryString.toLowerCase()) != -1) ||
                (textValue.alias && textValue.alias.toLowerCase().indexOf(queryString.toLowerCase()) != -1)
            }
        },
        str(i) {
            return i.toString()
        },
        m_placeholder(str) {
            return this.placeholder || str
        },
        focus(e) {
            e.target.select()
            this.KeyUpandDown(e)
        },
        imgclick(e) {
            this.$emit(`imgclick`)
        },
        imgdelete(e) {
            this.$emit(`imgdelete`, e)
        },
        KeyUpandDown(e) {
            let that = this
            let len = 0
            let collen = 0
            document.onkeydown = (v) => {
                if (v.keyCode !== 13 && v.keyCode !== 37 && v.keyCode !== 38 && v.keyCode !== 39 && v.keyCode !== 40) {
                    return
                }
                let curel = v.srcElement
                if (curel.nodeName.toLocaleLowerCase() !== `input`) {
                    // return document.onkeydown = null
                    return
                }

                while (curel.nodeName.toLocaleLowerCase() !== `td` && curel.nodeName.toLocaleLowerCase() !== `body`) {
                    curel = curel.parentElement
                }
                if (curel.nodeName.toLocaleLowerCase() === `body`) {
                    // return document.onkeydown = null
                    return
                }
                let curcellIndex = curel.cellIndex // 当前元素列单元格索引
                // 当前所在table（this.list） 的行的index : sectionRowIndex
                let index = curel.parentElement.sectionRowIndex
                let curtbody = curel.parentElement // 当前tbody内容的整个表单
                collen = curtbody.cells.length // 列数

                while (curtbody.nodeName.toLocaleLowerCase() !== `tbody`) {
                    curtbody = curtbody.parentElement
                }
                len = curtbody.children.length // 行数
                // 13 enter| 40 下 |  38 上|  37 左|  39 右
                let flag = false
                let direction = ``

                if (v.keyCode === 40) {
                    flag = true
                    index += 1
                    direction = `down`
                    if (index === len) { index = 0 }
                    let nextCells = curtbody.children[index].cells.length
                    if (collen > nextCells) {
                        // 处理行列合并的问题
                        curcellIndex = curcellIndex - 1
                    }
                    if (collen < nextCells) {
                        // 处理行列合并的问题
                        curcellIndex = curcellIndex + 1
                    }
                }
                if (v.keyCode === 38) {
                    flag = true
                    index -= 1
                    direction = `up`
                    if (index < 0) { index = len - 1 }
                    let presCells = curtbody.children[index].cells.length
                    if (presCells > collen) {
                        // 处理行列合并的问题
                        curcellIndex = curcellIndex + 1
                    }
                    if (presCells < collen) {
                        // 处理行列合并的问题
                        curcellIndex = curcellIndex - 1
                    }
                }

                if (v.keyCode === 37) {
                    flag = true
                    curcellIndex -= 1
                    direction = `left`
                    if (curcellIndex < 0) { curcellIndex = collen - 1 }
                }

                if (v.keyCode === 39) {
                    flag = true
                    curcellIndex += 1
                    direction = `right`
                    if (curcellIndex === collen) { curcellIndex = 0 }
                }

                if (v.keyCode === 13) {
                    flag = true
                    curcellIndex += 1
                    direction = `enter`
                    if (curcellIndex === collen) {
                        curcellIndex = 0
                        index += 1
                        if (index === len) { index = 0 }
                    }
                }

                if (flag) {
                    setTimeout(() => {
                        that.$emit(`activeRow`, index, curcellIndex, direction)
                    }, 100)
                }
            }
        },
        addDay(day) {
            let d = this.$moment(this._datevalue)
            if (d._isValid) {
                this._datevalue = d.add(day, `days`).format(`YYYY/MM/DD HH:mm`)
            } else {
                this._datevalue = this.$moment().format(`YYYY/MM/DD HH:mm`)
            }
            this.change()
        },
        change2(val) {
            let v
            switch (this.type) {
            case `datetime-local`:
                let rd = this.$moment(this._localdatevalue).format(`YYYY/MM/DD HH:mm`)
                console.log(`rd`, rd)
                v = rd
                break
            }
            this.$emit(`input`, v)
        },
        change(val) {
            let v
            switch (this.type) {
            case `float`:
                v = parseFloat(this._numberValue) || 0
                v = this._numberValue
                break
            case `number`:
                v = (this._numberValue && parseInt(this._numberValue)) || ``
                break
            case `numberWithSlot`:
                v = (this._numberValue && parseInt(this._numberValue)) || ``
                break
            case `integer`:
                v = this._numberValue
                break
            case `integer1`:
                v = this._numberValue
                break
            case `time`:
                v = (this._timevalue && this.$moment(this._timevalue, `HH:mm`).format(`YYYY/MM/DD HH:mm:ss`)) || ``
                break
            case `month`:
                v = (this._datevalue && this.$moment(this._datevalue).format(`YYYY/MM`)) || ``
                break
            case `date`:
            case `datearraw`:
            case `datearraw2`:
            case `datetime`:
            case `hhdatetime`:
                v = (this._datevalue && this.$moment(this._datevalue).format(`YYYY/MM/DD HH:mm:ss`)) || ``
                break
            case `daterange`:
                v = (this._datevalue &&
                        this._datevalue.map((v, index) => {
                            let d = this.$moment(v)
                            if (d.isValid()) {
                                return index == 0 ? d.format(`YYYY/MM/DD`) : d.format(`YYYY/MM/DD 23:59:59`)
                            } else {
                                return ``
                            }
                        })) || [``, ``]
                break
            case `datetimerange`:
                v = (this._datevalue &&
                    this._datevalue.map((v, index) => {
                        let d = this.$moment(v)
                        if (d.isValid()) {
                            return index == 0 ? d.format(`YYYY/MM/DD HH:mm:00`) : d.format(`YYYY/MM/DD HH:mm:59`)
                        } else {
                            return ``
                        }
                    })) || [``, ``]
                break
            case `string`:
            case `string1`:
            case `scan`:
            case `search`:
            case `select`:
            case `selectnotCode`:
            case `select1`:
            case `selectAllowCreate`:
            case `groupselect`:
            case `cascader`:
            case `radio`:
            case `textarea`:
            case `textarea1`:
                v = this._textValue
                break
            case `multiselect`:
            case `groupmultiselect`:
                v = this._multiSelectValue
                break
            case `remotemultiselect`:
                v = this._remoteMultiSelectValue
                break
            case `remoteselect`:
            case `remoteselecttable`:
            case `tableselect`:
                v = this.remoteSelectValue
                break
            case `checkboxgroup`:
                v = _.filter(this._listValue, function(l) {
                    return l !== ``
                })
                // v = _.join(lv, ',')
                break
            case `bool`:
            case `checkbox`:
                v = this._checked
                break
            case `rbool`:
                v = !this._checked
                break
            case `table`:
                v = this._tablerows
                break
            case `itemgroup`:
                v = val
                break
            case `colorpicker`:
                v = this._color
                break
            case `upload`:
                v = this.fileList
                break
            }

            this.$emit(`input`, v)
        },
        timeForm(time) {
            console.log(time)

            let now = new Date(this.$moment(time).format(`YYYY/MM/DD HH:mm`))
            console.log(now)
            let year = now.getFullYear()
            let month = now.getMonth() + 1
            month = month < 10 ? `0` + month : month
            let day = now.getDate()
            day = day < 10 ? `0` + day : day
            let hour = now.getHours()
            hour = hour < 10 ? `0` + hour : hour
            let min = now.getMinutes()
            min = min < 10 ? `0` + min : min
            let timeValue = year + `-` + month + `-` + day + `T` + hour + `:` + min
            return timeValue
        },
        input() {
            let v = this.remoteAutoSelectValue
            console.log(`input` + v)
            // this.$emit(`input`, v)
        },
        blur() {
            let v
            if (this.type === `string` || this.type === `string1`) {
                v = this._textValue
            }
            this.$emit(`blur`, v)
        },
        enter() {
            this.$emit(`input`, this.scan_val)
            // this.scan_val = ``
        },
        handleCommand(command) {
            this.$emit(`input`, command.value)
        },
        selectedIcon(op) {
            this.$emit(`input`, op.value)
            // this.textValue=op.value
        },

        tableSelectFetch: _.debounce(function(query) {
            if (query !== ``) {
                this.remote_keyword = query

                let promise
                let q = {}
                if (_.trim(this.remote_keyword).length > 0) {
                    q.keyword = _.trim(this.remote_keyword)
                }
                if (typeof this.remoteUrl === `function`) {
                    promise = Promise.resolve(this.remoteUrl(q))
                } else {
                    promise = this.myaxios.get(this.remoteUrl, q)
                }
                promise
                    .then(data => {
                        console.log(data, `ddd`)
                        this.loading = false
                        const [item] = this.selectOption
                        const index = item ? data.findIndex(option => option.value === item.value) : -1
                        if (index !== -1) {
                            const current = data.splice(index, 1)
                            this.remoteList = [...current, ...data]
                        } else {
                            this.remoteList = data
                        }
                    })
                    .catch(res => {
                        console.error(`load data faild.`, res)
                        this.loading = false
                    })
            } else {
                this.remoteList = []
            }
        }, 300),
        remoteSearch: _.debounce(function() {
            let promise
            let q = {}
            if (_.trim(this.remote_keyword).length > 0) {
                q.keyword = _.trim(this.remote_keyword)
            }
            if (typeof this.remoteUrl === `function`) {
                promise = Promise.resolve(this.remoteUrl(q))
            } else {
                promise = this.myaxios.get(this.remoteUrl, q)
            }
            promise
                .then(data => {
                    this.loading = false
                    let ops = data && _.take(data, 50)
                    ops = _.differenceBy(ops, this.selectOption, `value`)
                    // return this.selectOption.concat(ops)
                    if (q.keyword && q.keyword.length > 0) {
                        ops = _.filter(ops, d => {
                            let result = true
                            result = (d.label && d.label.toUpperCase().indexOf(q.keyword.toUpperCase()) > -1) ||
                                     (d.code && d.code.toUpperCase().indexOf(q.keyword.toUpperCase()) > -1) ||
                                (d.jianpin && d.jianpin.toUpperCase().indexOf(q.keyword.toUpperCase()) > -1) ||
                                 (d.abbr && d.abbr.toUpperCase().indexOf(q.keyword.toUpperCase()) > -1) ||
                                (d.card_no && d.card_no.toUpperCase().indexOf(q.keyword.toUpperCase()) > -1)

                            return result
                        })
                    }
                    this.remoteList = this.selectOption.concat(ops)
                })
                .catch(res => {
                    console.error(`load data faild.`, res)
                    this.loading = false
                })
        }, 300),

        remoteMethod(query) {
            if (query !== ``) {
                this.loading = true
                this.remote_keyword = query
                this.remoteSearch()
            } else {
                this.remoteList = []
            }
        },
        handleSelect(item) {
            console.log(this.remoteAutoSelectValue)
            this.remoteAutoSelectValue = item.value
            this.$emit(`change`, item.value, item.id)
        },
        blurchange() {
            let v = this.remoteAutoSelectValue
            console.log(this.remoteAutoSelectValue)
            this.$emit(`change`, v, 0)
        },
        filterMethod(q) {
            this.searchKey = q
        },
        // 下拉树输入框关键字
        dataFilter(val) {
            this.$refs.tree.filter(val)
        },
        // 下拉树节点过滤
        filterNode(value, data) {
            if (!value) return true
            return data[this.defaultProps.label].toLowerCase().indexOf(value.toLowerCase()) !== -1
        },
        removeRow({ index, row }) {
            this._tablerows.splice(index, 1)
            this.change()
        },
        addRow() {
            let row = { ___index: _.now() }
            _.forEach(this._options, op => {
                if (_.isBoolean(op.default) || op.default) {
                    row[op.prop] = op.default
                }
            })
            this._tablerows.push(row)
            this.$nextTick(() => {
                let $scroller = this.$refs.table1.$refs[`cus-table`].bodyWrapper
                $scroller.scrollTop = $scroller.scrollHeight + 1000
            })
            this.change()
        },
        ExtraButtonClick(target) {
            let e = {}
            ;({ index: e.index, row: e.row } = target)
            if (this[target.emit]) {
                this[target.emit](e)
            } else {
                this.$emit(`extrabutton-click`, target)
            }
        },
        exceed(files, fileList) {
            this.onExceed && this.onExceed(files, fileList)
        },
        handleFileSuccess(response, file, fileList) {
            this.onFileSuccess(response, file, fileList)
        },
        _beforeUpload(file) {
            if (this.beforeUpload) {
                return this.beforeUpload(file)
            } else {
                return true
            }
        },
        _removefile(file, fileList) {
            this.removeFile && this.removeFile(file, fileList)
        },
        _uploadError() {
            this.$message({
                type: `error`,
                message: `上传失败`
            })
        },
        remotemultiselectValueChanged() {
            this.countDom.style.display = `none`
            this.countDom.innerHTML = ``
            if (!this.remoteMultiSelectValue || this.remoteMultiSelectValue.length == 0) {
                return
            }
            if (this.remoteMultiSelectValue.length <= this.showCount) {
                this.$nextTick(() => {
                    let awaitUntilEqual = () => {
                        if (!this.$refs.remotemultiselectRef || !this.$refs.remotemultiselectRef.$el) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        let elTags = this.$refs.remotemultiselectRef.$el.querySelectorAll(`.el-tag`)
                        if (elTags.length != this.remoteMultiSelectValue.length) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        elTags.forEach((elTag, index) => {
                            elTag.style.display = `inline-block`
                        })
                    }
                    awaitUntilEqual()
                })
            } else {
                this.countDom.style.display = `inline-block`
                this.countDom.innerHTML = `+ ` + (this.remoteMultiSelectValue.length - this.showCount)
                this.$nextTick(() => {
                    let awaitUntilEqual = () => {
                        if (!this.$refs.remotemultiselectRef || !this.$refs.remotemultiselectRef.$el) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        let elTags = this.$refs.remotemultiselectRef.$el.querySelectorAll(`.el-tag`)
                        if (elTags.length != this.remoteMultiSelectValue.length) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        elTags.forEach((elTag, index) => {
                            if (index >= this.showCount) {
                                elTag.style.display = `none`
                            } else {
                                elTag.style.display = `inline-block`
                            }
                        })
                    }
                    awaitUntilEqual()
                })
            }
        },
        remotemultiselectCountDom() {
            if (this.$refs.remotemultiselectRef && this.$refs.remotemultiselectRef.$el) {
                let span = this.$refs.remotemultiselectRef.$el.querySelector(`.el-select__tags > span`)
                let input = this.$refs.remotemultiselectRef.$el.querySelector(`.el-select__tags > input`)
                if (span) {
                    span.after(this.countDom)
                } else if (input) {
                    input.after(this.countDom)
                }
            } else {
                this.$nextTick(() => {
                    if (this.$refs.remotemultiselectRef && this.$refs.remotemultiselectRef.$el) {
                        let span = this.$refs.remotemultiselectRef.$el.querySelector(`.el-select__tags > span`)
                        let input = this.$refs.remotemultiselectRef.$el.querySelector(`.el-select__tags > input`)
                        if (span) {
                            span.after(this.countDom)
                        } else if (input) {
                            input.after(this.countDom)
                        }
                    }
                })
            }
        },
        multiselectValueChanged() {
            this.countDom.style.display = `none`
            this.countDom.innerHTML = ``
            if (!this.multiSelectValue || this.multiSelectValue.length == 0) {
                return
            }
            if (this.multiSelectValue.length <= this.showCount) {
                this.$nextTick(() => {
                    let awaitUntilEqual = () => {
                        if (!this.$refs.multiselectRef || !this.$refs.multiselectRef.$el) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        let elTags = this.$refs.multiselectRef.$el.querySelectorAll(`.el-tag`)
                        if (elTags.length != this.multiSelectValue.length) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        elTags.forEach((elTag, index) => {
                            elTag.style.display = `inline-block`
                        })
                    }
                    awaitUntilEqual()
                })
            } else {
                this.countDom.style.display = `inline-block`
                this.countDom.innerHTML = `+ ` + (this.multiSelectValue.length - this.showCount)
                this.$nextTick(() => {
                    let awaitUntilEqual = () => {
                        if (!this.$refs.multiselectRef || !this.$refs.multiselectRef.$el) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        let elTags = this.$refs.multiselectRef.$el.querySelectorAll(`.el-tag`)
                        if (elTags.length != this.multiSelectValue.length) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        elTags.forEach((elTag, index) => {
                            if (index >= this.showCount) {
                                elTag.style.display = `none`
                            } else {
                                elTag.style.display = `inline-block`
                            }
                        })
                    }
                    awaitUntilEqual()
                })
            }
        },
        multiselectCountDom() {
            if (this.$refs.multiselectRef && this.$refs.multiselectRef.$el) {
                let span = this.$refs.multiselectRef.$el.querySelector(`.el-select__tags > span`)
                let input = this.$refs.multiselectRef.$el.querySelector(`.el-select__tags > input`)
                if (span) {
                    span.after(this.countDom)
                } else if (input) {
                    input.after(this.countDom)
                }
            } else {
                this.$nextTick(() => {
                    if (this.$refs.multiselectRef && this.$refs.multiselectRef.$el) {
                        let span = this.$refs.multiselectRef.$el.querySelector(`.el-select__tags > span`)
                        let input = this.$refs.multiselectRef.$el.querySelector(`.el-select__tags > input`)
                        if (span) {
                            span.after(this.countDom)
                        } else if (input) {
                            input.after(this.countDom)
                        }
                    }
                })
            }
        }
    },
    mounted() {
        if (this.type == `remotemultiselect` && this.showCount > 1) {
            this.remotemultiselectCountDom()
            this.remotemultiselectValueChanged()
        }
        if (this.type == `multiselect` && this.showCount > 1) {
            this.multiselectCountDom()
            this.multiselectValueChanged()
        }
    },
    watch: {
        remoteMultiSelectValue: function(old, newData) {
            if (this.type == `remotemultiselect` && this.showCount > 1) {
                this.remotemultiselectValueChanged()
            }
        },
        multiSelectValue: function(old, newData) {
            if (this.type == `multiselect` && this.showCount > 1) {
                this.multiselectValueChanged()
            }
        },
        value: {
            handler(val) {
                if (this.type == `selecttree`) {
                    this.select_tree = []
                    this.select_tree_names = []
                    let alloptions = this.flatten(this._options)
                    if (this.value && this.value.length > 0) {
                        let selectedtree = _.filter(alloptions, c => {
                            return _.includes(this.value, c.value)
                        })
                        this.select_tree = selectedtree
                        this.select_tree_names = selectedtree.map(s => s.label)
                    }

                    if (this.showCount > 1) {
                        this.selectTreeCountDom()
                        this.selectTreeValueChanged()
                    }
                }
            },
            immediate: true
        }
    }
}
</script>
<style scoped lang="less">
/deep/ .count-node {
    height: 24px;
    padding: 0 4px;
    line-height: 22px;
    margin-left: 6px;
    background-color: #f4f4f5;
    border: 1px solid #e9e9eb;
    border-radius: 4px;
    color: #0a76a4;
    font-size: 12px;
    box-sizing: border-box;
    display: block;
}
.el-select {
    width: 100%;
}

.myautocomplete {
    width: 318px;
}
.el-input-number {
    width: 100%;
    min-width: 100px;
}
.fas-icon-list {
    padding: 10px;
    margin-top: 30px;
    li {
        list-style-type: none;
        display: table-row;
    }
}
.el-checkbox-group,
.el-radio-group {
    // float: left;
    text-align: left;
}
.el-checkbox,
.el-radio {
    margin-left: 0 !important;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item {
    padding-right: 20px;
}
</style>
<style lang="less">
.none-padding.datetime,
.none-padding.date,
.datearraw2 {
    // .el-input--suffix .el-input__inner {
    //     padding-right: 0;
    // }
    // .el-input--prefix  .el-input__inner {
    //     padding-left: 0;
    // }
    .el-input__prefix {
        display: none;
    }

    input {
        text-align: center;
    }
    .el-input__inner {
        padding-left: 5px !important;
        padding-right: 5px !important;
    }
}
.flexselectOneValue {
    display: flex;
    justify-content: center;
}
.flexSelect {
    display: flex;
    justify-content: space-around;
}
.integer,
.number,
.float,
.string,
.groupselect,
.select,
.groupselect,
.multiselect,
.groupmultiselect,
.remoteselect,
.remotemultiselect {
    .el-input__inner {
        padding-left: 5px !important;
    }
    &.el-input--suffix .el-input__inner {
        padding-right: 5px !important;
    }
    .el-input--suffix .el-input__inner {
        padding-right: 5px !important;
    }
    .el-input__prefix {
        display: none;
    }
}
.search {
    .el-input__inner {
        padding-left: 5px !important;
    }
    .el-input__prefix {
        display: none;
    }
}

.groupselect,
.select,
.groupselect,
.multiselect,
.groupmultiselect,
.remoteselect,
.remotemultiselect {
    line-height: 38px;
}
.daterange {
    width: 100%;
    input {
        width: 45% !important;
    }
    .el-range-editor {
        width: 100% !important;
    }
    .el-range-separator {
        width: 15px !important;
    }
    &.none-padding {
        .el-input__icon {
            display: none !important;
        }
        .el-range__close-icon {
            display: none !important;
        }
    }
}
.option_img {
    float: left;
    padding: 9px 1px;
    width: 16px;
    height: 16px;
}
.option_img:hover {
    cursor: pointer;
    transform: scale(1.2);
}

#reader {
    video {
        width: 600px !important;
    }
}
// .el-input__inner{
//   padding-left:5px !important;
// }
.theme-dark .el-textarea.is-disabled .el-textarea__inner,
.theme-his-blue .el-textarea.is-disabled .el-textarea__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    border-top-color: rgb(228, 231, 237);
    border-right-color: rgb(228, 231, 237);
    border-bottom-color: rgb(228, 231, 237);
    border-left-color: rgb(228, 231, 237);
    color: #606266 !important;
    cursor: not-allowed;
}
</style>

<style scoped lang="less">
.tree-select__option {
    min-height: 200px;
    cursor: default !important;
    padding: 0 !important;
    margin: 0;
    overflow: auto !important;
    background-color: #fff !important;
    .el-select-dropdown__item {
        height: auto;
        line-height: 1;
        padding: 0;
        background-color: #fff !important;
    }
}

.tree-select__tree {
    padding: 4px 20px;
    font-weight: 400;
}

.inputlocal {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 2px 0px 2px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 175px;
    height: 32px;
    margin-top: 5px;
}
.selecttablelable {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    padding-right: 5px;
}
.selecttablecode {
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 5px;
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/common/ItemInput.vue